import { Link } from 'react-router-dom'

import styles from './choose-category.module.css'
import { Logo } from './logo/logo';
import productOverview from '../img/product-overview.jpg';
import { buttonStyle } from '../controls/buttons';

// In this module texts are not retrieved from the messages hook because
// the user has not yet chosen a language.

const LANGUAGES = [
    { name: 'English', code: 'en' },
    { name: 'Nederlands', code: 'nl' },
    { name: 'Français', code: 'fr' },
    { name: 'Deutsch', code: 'de' },
]

export function ChooseLanguageButton({ onLanguageSelected, disabled }: {
    onLanguageSelected: (lang:string) => void
    disabled?: boolean
}) {
    return <div role="presentation" className={styles.chooseCategory}>
        <div role="presentation" className={styles.menuHeader}><Logo/></div>
        <ul className={styles.menu}>
        {
            LANGUAGES.map(l => <li key={l.code}>
                <button className={buttonStyle} onClick={() => onLanguageSelected(l.code)} disabled={disabled}>{ l.name }</button>
            </li>)
        }
       </ul>
        <img className={styles.image} src={productOverview} alt="" />
    </div>
}

export function ChooseLanguageLink({ disabled, searchParams }: {
    disabled?: boolean
    searchParams?: URLSearchParams
}) {

    const makeURL = (lang: string) => {
        let searchParamsChunk = '';
        if(searchParams && searchParams.size > 0) {
            searchParamsChunk = '?' + searchParams.toString();
        }
        return `/${lang}${searchParamsChunk}`;
    }

    return <div role="presentation" className={styles.chooseCategory}>
        <div role="presentation" className={styles.menuHeader}><Logo/></div>
        <ul className={styles.menu}>
            { disabled ? 
                    <>
                        <li><span className={buttonStyle}>English</span></li>
                        <li><span className={buttonStyle}>Nederlands</span></li>
                        <li><span className={buttonStyle}>Français</span></li>
                        <li><span className={buttonStyle}>Deutsch</span></li>
                    </>
                    :
                    <>
                        <li><Link className={buttonStyle} to={makeURL('en')}>English</Link></li>
                        <li><Link className={buttonStyle} to={makeURL('nl')}>Nederlands</Link></li>
                        <li><Link className={buttonStyle} to={makeURL('fr')}>Français</Link></li>
                        <li><Link className={buttonStyle} to={makeURL('de')}>Deutsch</Link></li>
                    </>
            }
        </ul>
        <img className={styles.image} src={productOverview} alt="" />
    </div>

}